// eslint-disable-next-line
export const form_options = {
	role: ['Manager', 'Employee']
}

export const religions = ['Islam', 'Hinduism', 'Christianity', 'Others']
export const regions = ['UAE', 'India']
